import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import type { Review } from '../data/site';
import { AgreexaMark } from './AgreexaMark';
interface TrustScorePanelProps {
  review: Pick<Review, 'trustScore' | 'recommendation' | 'dimensions'>;
}
export function TrustScorePanel({
  review
}: TrustScorePanelProps) {
  return <section className="rounded-sm border border-stone-200 bg-white overflow-hidden" aria-label="Agreexa Trust Framework verification" data-id="element-188">
      {/* Verified header */}
      <div className="bg-ink text-paper px-6 py-5 flex items-center gap-3" data-id="element-189">
        <ShieldCheckIcon className="h-6 w-6 text-trust-300 shrink-0" data-id="element-190" />
        <div data-id="element-191">
          <p className="eyebrow text-stone-400" style={{
          fontSize: '0.6rem'
        }} data-id="element-192">
            Verified by
          </p>
          <AgreexaMark tone="light" className="text-base" data-id="element-193" />
          <p className="text-[0.65rem] text-stone-400 tracking-wide" data-id="element-194">
            Trust Framework®
          </p>
        </div>
      </div>

      <div className="p-6 md:p-8" data-id="element-195">
        {/* Overall score */}
        <div className="flex items-end justify-between border-b border-stone-200 pb-6" data-id="element-196">
          <div data-id="element-197">
            <p className="eyebrow text-stone-500 mb-1" data-id="element-198">Overall Trust Score</p>
            <p className="font-serif text-5xl tracking-tightest text-ink" style={{
            fontWeight: 600
          }} data-id="element-199">
              {review.trustScore}
              <span className="text-2xl text-stone-400" data-id="element-200">/100</span>
            </p>
          </div>
          <div className="text-right" data-id="element-201">
            <p className="eyebrow text-stone-500 mb-1" data-id="element-202">
              Editor’s Recommendation
            </p>
            <span className="inline-block bg-trust-50 text-trust-700 border border-trust-200 px-3 py-1 text-sm font-600 rounded-sm" data-id="element-203">
              {review.recommendation}
            </span>
          </div>
        </div>

        {/* Dimensions */}
        <ul className="mt-6 space-y-4" data-id="element-204">
          {review.dimensions.map((d, i) => <li key={d.label} data-id="element-205">
              <div className="flex items-center justify-between mb-1.5" data-id="element-206">
                <span className="text-sm text-stone-700 font-500" data-id="element-207">
                  {d.label}
                </span>
                <span className="text-sm text-ink font-600 tabular-nums" data-id="element-208">
                  {d.score}
                </span>
              </div>
              <div className="h-1.5 w-full bg-stone-100 rounded-full overflow-hidden" data-id="element-209">
                <motion.div className="h-full bg-trust-500 rounded-full" initial={{
              width: 0
            }} whileInView={{
              width: `${d.score}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: i * 0.06,
              ease: 'easeOut'
            }} data-id="element-210" />
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}